import React from 'react';

const ConnectedIcon = ({ width = 25, height = 25 }) => (
  <svg width={width} height={height} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 12.9998H17M10 8.71484H7C5.93913 8.71484 4.92172 9.1663 4.17157 9.96989C3.42143 10.7735 3 11.8634 3 12.9998C3 14.1363 3.42143 15.2262 4.17157 16.0298C4.92172 16.8334 5.93913 17.2848 7 17.2848H10M16 8.71484H19C20.0609 8.71484 21.0783 9.1663 21.8284 9.96989C22.5786 10.7735 23 11.8634 23 12.9998C23 14.1363 22.5786 15.2262 21.8284 16.0298C21.0783 16.8334 20.0609 17.2848 19 17.2848H16" stroke="#67B673" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default ConnectedIcon;
